/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formcontent_Thanksrecruitment2Inputs */

const ja_contact_formcontent_thanksrecruitment2 = /** @type {(inputs: Contact_Formcontent_Thanksrecruitment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご応募いただきありがとうございました！追って採用担当者よりご連絡させていただきます。以下、応募内容となります。`)
};

const en_contact_formcontent_thanksrecruitment2 = /** @type {(inputs: Contact_Formcontent_Thanksrecruitment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your Enquiry! A representative will contact you shortly. Below is the content of your Enquiry.`)
};

/**
* | output |
* | --- |
* | "Thank you for your Enquiry! A representative will contact you shortly. Below is the content of your Enquiry." |
*
* @param {Contact_Formcontent_Thanksrecruitment2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formcontent_thanksrecruitment2 = /** @type {((inputs?: Contact_Formcontent_Thanksrecruitment2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formcontent_Thanksrecruitment2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formcontent_thanksrecruitment2(inputs)
	return en_contact_formcontent_thanksrecruitment2(inputs)
});
export { contact_formcontent_thanksrecruitment2 as "contact_formContent_thanksRecruitment" }